export const environment = {
  production: false,
  // apiUrl: 'https://api.samtogether.com/api'
  apiUrl: 'https://api.harumart.net/api',
  //apiUrl: 'http://localhost:42445/api',
  //imageUrl: '/assets/images/products',
  imageUrl: 'https://images.harumart.net',
  webUrl: 'https://daily.harumart.net/'
  //webUrl: 'https://localhost:5000/'
};
